import { useContext } from 'react';
import { UIVersionContext } from '../contextProviders/SplashScreenProviders/UserAndAccountProviders/UIVersionProvider';

const V1V2AccountsOnly = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  const { uiVersion } = useContext(UIVersionContext);

  if (uiVersion === 'v3') {
    return null;
  }

  return <>{children}</>;
};

export default V1V2AccountsOnly;
